// ReportIssue.tsx · v12.10.30 (#2255 Report issue on the three offline pages - taken offline, you're offline, we'll be right back) · 2026-11-03 · VoiceSpectrum AI
//
// v12.10.30 (#2255, Tushar 11/3 ~5:30 PM): "Report issue" - one click, an optional one-line note, and it lands on ONE grouped ticket in
// Support Ops › Support requests (per practice for the two offline pages, per incident for maintenance). Clicked again within 10 minutes it
// is not counted: "Already reported at 7:42 PM". On "you're offline" it waits on this device until the connection is back; on "we'll be
// right back" it is retried until VoiceSpectrum answers again.
import { useState } from 'react';
import { reportAnswerText, sendReport, type ReportAnswer, type ReportKind } from '../lib/practiceOffline';

export default function ReportIssue({ kind, downSince, onOnline }: { kind: ReportKind; downSince?: number | null; onOnline?: () => void }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [answer, setAnswer] = useState<ReportAnswer | null>(null);

  async function send() {
    setBusy(true);
    const a = await sendReport(kind, note, downSince ?? null);
    setBusy(false);
    setAnswer(a);
    if (a.status !== 'error') { setOpen(false); setNote(''); }
    if (a.status === 'online') onOnline?.();
  }

  return (
    <div className="vs-maint-report" data-testid={`report-issue-${kind}`}>
      {!open && (
        <button type="button" className="vs-maint-link" onClick={() => { setOpen(true); setAnswer(null); }}>Report issue</button>
      )}
      {open && (
        <form className="vs-maint-report-form" onSubmit={(e) => { e.preventDefault(); if (!busy) void send(); }}>
          <label className="vs-maint-report-label" htmlFor={`vs-report-note-${kind}`}>Anything to add? <span>(optional)</span></label>
          <input id={`vs-report-note-${kind}`} className="vs-maint-report-input" value={note} maxLength={300} autoComplete="off"
            onChange={(e) => setNote(e.target.value)} autoFocus />
          <div className="vs-maint-report-actions">
            <button type="submit" className="vs-maint-btn" disabled={busy}>{busy ? 'Sending…' : 'Send report'}</button>
            <button type="button" className="vs-maint-link" onClick={() => setOpen(false)} disabled={busy}>Cancel</button>
          </div>
        </form>
      )}
      {answer && <div className={`vs-maint-report-answer${answer.status === 'error' ? ' is-err' : ''}`} role="status">{reportAnswerText(kind, answer)}</div>}
    </div>
  );
}
